// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input, OnChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { dashboardSummaryRequested } from '../../store/dashboard-summary.actions';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { Observable } from 'rxjs';
import {
  selectAreCompetitorsDefined,
  selectDashboardSummary,
  selectDashboardSummaryError,
  selectIsLoading,
} from '../../store/dashboard-summary.selectors';
import { DashboardSummary } from '../../models/dashboard-summary';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupTypes } from '@coa/app/shared/filters/select-group-types/models/group-types';

@Component({
  selector: 'coa-dashboard-summary',
  templateUrl: './dashboard-summary.component.html',
  styleUrls: ['./dashboard-summary.component.scss'],
})
export class DashboardSummaryComponent implements OnChanges {
  @Input() categoryId: string;
  @Input() clientId: string;
  @Input() dateRange: DateRangeFilter;

  isLoading$: Observable<boolean> = this.store$.pipe(select(selectIsLoading));
  isError$: Observable<boolean> = this.store$.pipe(select(selectDashboardSummaryError));
  dashboardSummary$: Observable<DashboardSummary> = this.store$.pipe(select(selectDashboardSummary));
  competitorsDefined$: Observable<boolean> = this.store$.pipe(select(selectAreCompetitorsDefined));

  constructor(
    private store$: Store,
    private activatedRoute: ActivatedRoute,
    private router: Router) {
  }

  ngOnChanges(): void {
    if (this.clientId && this.dateRange) {
      this.requestData();
    }
  }

  translate(key: string, lang: string): string {
    return `${ key } LANG:${ lang }`;
  }

  showOwn(): void {
    this.router.navigate(['clients', this.clientId, 'stores'], {
      queryParams: {groupTypes: GroupTypes.OWN, dateRange: this.dateRange, categoryId: this.categoryId},
      queryParamsHandling: 'merge',
    });
  }

  showCompetitors(): void {
    this.router.navigate(['clients', this.clientId, 'stores'], {
      queryParams: {groupTypes: GroupTypes.COMPETITORS, dateRange: this.dateRange, categoryId: this.categoryId},
      queryParamsHandling: 'merge',
    });
  }

  redirect(id: number): void {
    this.router.navigate(['/clients', this.clientId, 'stores', id.toString()], {queryParams: {dateRange: this.dateRange}});
  }

  private requestData(): void {
    this.store$.dispatch(dashboardSummaryRequested({
      timePeriod: this.dateRange,
      clientId: this.clientId,
      categoryId: this.categoryId,
    }));
  }
}
